<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
            <span
                v-if="!$_updateActionAllowed"
                class="lock"
                :title="'Globální lokality. Nelze editovat' | translate"
                v-translate>S
			</span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed"  :title="'Globální lokality. Nelze editovat' | translate" v-translate>Zamčeno</span>

    <td :data-th="'Název lokality' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Odstávka' | translate">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.maintenance"/>
    </td>
    <td :data-th="'Počet prefixů' | translate">
      {{ entity.ip_prefixes_count }}
    </td>
    <td :data-th="'Počet zdrojů obsahu' | translate">
      {{ entity.content_sources_count }}
    </td>
    <td v-if="$_deleteActionAllowed" class="no_padding edit">
      <div class="edit_inner">
        <a
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteLocality">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
    <td v-else class="no_padding"></td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "LocalityRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'localities',
      detailPageRouteName: 'localitiesDetail',
    }
  },
  methods: {
    emitDeleteLocality() {
      this.$emit('deleteLocality', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/localities/LocalityRow.vue